import { ViewPortType } from '@/engine/app/interfaces';
import { type ViewController } from '@/engine/app/View.controller';
import { TYPES } from '@/engine/ioc';
import { useInjection } from 'inversify-react';
import { useEffect } from 'react';

export const useDeviceOrientationChange = (): void => {
  const viewController = useInjection<ViewController>(TYPES.ViewController);

  useEffect(() => {
    const vpController = viewController.getViewPortController(ViewPortType.ThreeD);

    const handleOrientationChange = (): void => {
      setTimeout(() => {
        vpController?.fitCameraToObjects();
      }, 400);
    };

    const mediaQuery = window.matchMedia('(orientation: portrait)');
    mediaQuery.addEventListener('change', handleOrientationChange);

    return (): void => {
      mediaQuery.removeEventListener('change', handleOrientationChange);
    };
  }, [viewController]);
};
